import { GET_REGISTERED_USER_DISCOUNTS } from '../actions/types';

const initialState = {
    registered_user_discounts: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_REGISTERED_USER_DISCOUNTS:
            return {
                ...state,
                registered_user_discounts: action.payload
            }
        default:
            return state;
    }
}